import { render, staticRenderFns } from "./ImportWholesaleOrderPage.vue?vue&type=template&id=12083b77&scoped=true&"
import script from "./ImportWholesaleOrderPage.vue?vue&type=script&lang=js&"
export * from "./ImportWholesaleOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./ImportWholesaleOrderPage.vue?vue&type=style&index=0&id=12083b77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12083b77",
  null
  
)

export default component.exports